module.exports = __webpack_public_path__ + "static/media/5.2e993c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/5.png
// module id = 685
// module chunks = 0